import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
  Link,
} from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import * as routes from '../../config/routes';
import * as authActions from '../actions';
import Layout from '../../main/components/Layout';
import Alert from '../../common/components/Alert';
import FormErrorDialog from '../../common/components/formErrorDialog';
import SetPasswordForm from '../components/SetPasswordForm';
import classes from '../../css/getCSS';

class SetPassword extends Component {
  componentDidMount() {
    document.title = 'Set your new password';
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  inputChangedHandler = (event, field) => {
    this.props.inputChangedHandler(
      event,
      field,
      'setPasswordForm',
      this.props.inputs,
    );
  }

  submitHandler = (event) => {
    this.props.doSetPassword(
      event,
      'setPasswordForm',
      this.props.inputs,
      this.props.match.params.uid,
      this.props.match.params.token,
    );
  }

  render() {
    let displayForm = (
      <form method="post" onSubmit={this.submitHandler}>
        <SetPasswordForm
          inputs={this.props.inputs}
          inputChangedHandler={this.inputChangedHandler}
        />
      </form>
    );

    if (this.props.loading) {
      displayForm = (
        <div align="center"><CircularProgress align="center" size={50} /></div>
      );
    }

    let nonFieldErrors = null;
    if (this.props.errors) {
      nonFieldErrors = this.props.errors.map((error) => {
        return (
          <Alert key={error} type="danger">{error}</Alert>
        );
      });
    }

    if (this.props.errors.token || this.props.errors.uid) {
      nonFieldErrors = <Alert type="danger">Set password link is expired. Please generate another by clicking forgot password.</Alert>;
    }

    if (this.props.success) {
      displayForm = <Alert type="success">{this.props.success}</Alert>;
    }

    return (
      <Layout hideNavbar rootClass={[classes.loginBack].join(' ')} background>
        <Grid container style={{ justifyContent: 'center' }}>
          <Grid item md={4} xs={12} sm={5} className={classes.padding15XS}>
            <Paper className={[classes.card, classes.cardFancy].join(' ')}>
              <br />
              <Typography variant="title" style={{ color: '#666' }}>Set new password</Typography>
              <br />
              {nonFieldErrors}
              <br />
              {displayForm}
              <br />
              <Typography variant="body1"><Link to={routes.LOGIN}>Back to Login</Link></Typography>
              <Typography variant="body1"><Link to={routes.PASSWORD_RESET}>Forgot Password?</Link></Typography>
            </Paper>
          </Grid>
        </Grid>
        <FormErrorDialog open={this.props.hasError} handleClose={this.props.toggleError} />
      </Layout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    inputs: state.auth.setPasswordForm,
    hasError: state.auth.hasError,
    errors: state.auth.errors,
    success: state.auth.success,
    loading: state.auth.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleError: () => dispatch(authActions.toggleError()),
    inputChangedHandler: (event, field, form, inputs) => dispatch(
      authActions.inputChangedHandler(event, field, form, inputs),
    ),
    doSetPassword: (event, form, inputs, uid, token) => dispatch(
      authActions.doSetPassword(event, form, inputs, uid, token),
    ),
    onUnmount: () => dispatch(authActions.onUnmount()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SetPassword));



// WEBPACK FOOTER //
// ./src/auth/containers/SetPassword.js